 $(document).ready(function(){
    $('.slider_pdp').slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
});
// ── Variant image switcher ──────────────────────────────────────────────────
if (!window._variantSwitcherSetup) {
  window._variantSwitcherSetup = true;
  var _productImages = null;
  var _productVariants = null;

  // Fetch product data via JSON API
  var _handle = document.querySelector('[data-product-handle]');
  var _slug = _handle ? _handle.getAttribute('data-product-handle') : window.location.pathname.split('/').pop();
  fetch('/products/' + _slug + '.json')
    .then(function(r) { return r.json(); })
    .then(function(d) {
      _productImages = d.product.images;
      _productVariants = d.product.variants;
      document.querySelectorAll('.product-options').forEach(function(g) {
        var f = g.querySelector('.option-value');
        if (f) f.classList.add('active');
      });
    });

  function _updateVariantSlide(variantId) {
    if (!_productImages) return;
    var idx = _productImages.findIndex(function(img) {
      return img.variant_ids && img.variant_ids.indexOf(variantId) >= 0;
    });
    if (idx < 0 && _productVariants) {
      var v = _productVariants.find(function(v) { return v.id === variantId; });
      if (v && v.featured_image) {
        idx = _productImages.findIndex(function(img) { return img.id === v.featured_image.id; });
      }
    }
    if (idx >= 0) { jQuery('.slider_pdp').slick('slickGoTo', idx); }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.option-value') : null;
    if (!btn || !_productVariants) return;
    var pos = btn.getAttribute('data-option');
    document.querySelectorAll('.option-value[data-option="' + pos + '"]').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    var sel = {};
    document.querySelectorAll('.option-value.active').forEach(function(b) { sel[b.getAttribute('data-option')] = b.getAttribute('data-value'); });
    var match = _productVariants.find(function(v) {
      return Object.keys(sel).every(function(p) { return v['option' + p] === sel[p]; });
    });
    if (match) _updateVariantSlide(match.id);
  });
}